import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import { useQuery } from "@tanstack/react-query";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { handleFetchBookings } from "../../apis/bookings";
import { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";

export default function Calendar() {
  const { site } = useContext(AuthContext);

  const { data: bookings } = useQuery({
    queryKey: ["bookings", site?._id],
    queryFn: () =>
      handleFetchBookings({ site: site?._id === 0 ? "" : site?._id }),
  });

  return (
    <div className="">
      <div className="grid grid-cols-12 gap-2 rounded-md shadow-sm border border-gray-200 m-2 pb-2">
        <div className="col-span-12 sm:col-span-6 p-2">
          <FullCalendar
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            initialView="timeGridWeek"
            hiddenDays={[0, 7]}
            headerToolbar={{
              left: "prev,next",
              center: "title",
              right: "timeGridDay, timeGridWeek"
            }}
            events={bookings?.records}
          />
        </div>
        <div className="col-span-12 sm:col-span-6  p-2">
          <FullCalendar
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            initialView="dayGridMonth"
            hiddenDays={[0, 7]}
            headerToolbar={{
              left: "prev,next",
              center: "title",
              right: "dayGridMonth",
            }}
            events={bookings?.records}
          />
        </div>

      </div>
    </div>
  );
}
